import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimProcessingRule extends IModelBase {
  Name: string
  EntityGroupId: number
  ClaimProcessingTypeId: number
  TransactionTypeId: number
  OutboundDirectory: string
}

@Injectable()
export class ClaimProcessingRuleODataService extends ODataService<IClaimProcessingRule> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimProcessingRules'
  }
}
